import React from 'react'
import PropTypes from 'prop-types'

import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'

const BLOCK_REASONS = [
  'Inappropriate messages',
  'Bad experience on a Lex',
  "Doesn't speak my languages",
  'Not in my area',
]

class BlockUserModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }

    this.blockUser = this.blockUser.bind(this)
    this.unblockUser = this.unblockUser.bind(this)
  }

  blockUser(reason) {
    if (this.state.loading) return

    this.setState({ loading: true })

    $.ajax({
      url: '/blocked_users',
      dataType: 'JSON',
      type: 'POST',
      data: {
        blocked_user: {
          reporter: this.props.currentUserId,
          blocked_user: this.props.userId,
          notes: reason,
        },
      },
      success: () => {
        this.props.onBlocked()
      },
      error: () => {
        this.setState({ loading: false })
      },
    })
  }

  unblockUser() {
    if (this.state.loading || !this.props.blockedRecordId) return

    this.setState({ loading: true })

    $.ajax({
      url: `/blocked_users/${this.props.blockedRecordId}`,
      dataType: 'JSON',
      type: 'DELETE',
      success: () => {
        this.props.onUnblocked()
      },
      error: () => {
        this.setState({ loading: false })
      },
    })
  }

  renderBlockContent() {
    const { userName } = this.props

    return (
      <div className="blockUserModal">
        <h2 className="blockUserModal__title">Block {userName}</h2>
        <p className="blockUserModal__text">
          Blocking another user will prevent them from contacting you.
        </p>
        <div className="blockUserModal__reasons">
          {BLOCK_REASONS.map((reason) => (
            <StandardButton
              key={reason}
              text={reason}
              fullWidth={true}
              disabled={this.state.loading}
              onClick={() => this.blockUser(reason)}
            />
          ))}
        </div>
      </div>
    )
  }

  renderUnblockContent() {
    const { userName } = this.props

    return (
      <div className="blockUserModal">
        <h2 className="blockUserModal__title">Unblock {userName}?</h2>
        <p className="blockUserModal__text">
          If you unblock {userName}, they will be able to request to connect with you again.
        </p>
        <StandardButton
          text="Yes, unblock"
          size="large"
          variant="destructive"
          fullWidth={true}
          disabled={this.state.loading}
          onClick={this.unblockUser}
        />
      </div>
    )
  }

  render() {
    const { isBlocker, onClose, userName } = this.props

    return (
      <StandardModal
        onClose={onClose}
        title={isBlocker ? `Unblock ${userName}` : `Block ${userName}`}
        modalClass="blockUserModal__shell"
      >
        {isBlocker ? this.renderUnblockContent() : this.renderBlockContent()}
      </StandardModal>
    )
  }
}

BlockUserModal.propTypes = {
  userId: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  currentUserId: PropTypes.number.isRequired,
  isBlocker: PropTypes.bool.isRequired,
  blockedRecordId: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onBlocked: PropTypes.func.isRequired,
  onUnblocked: PropTypes.func.isRequired,
}

export default BlockUserModal
